export const decodeJwtPayload = <T = any>(token: string): T | null => {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length !== 3) return null;

    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const decodedPayload = atob(base64);
        return JSON.parse(decodedPayload) as T;
    } catch (error) {
        throw new Error('Failed to decode JWT payload: ' + error);
    }
};
